import { gql } from 'graphql-request'

export const GET_AGE_VERIFY_USERS = gql`
  query FindAgeVerifyUsers(
    $limitPerPage: Int
    $page: Int
    $statusType: UserAgeVerifyStatusAdminEnum
    $searchText: String
    $orderBy: UserListsOrderBy
  ) {
    findAgeVerifyUsers(
      limitPerPage: $limitPerPage
      page: $page
      statusType: $statusType
      searchText: $searchText
      orderBy: $orderBy
    ) {
      data {
        id
        avatarImgPath
        username
        ageVerify
        ageUploadedAt
      }
      total
    }
  }
`
